var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.045,
    height: 36,
    viewBox: "0 0 87.045 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ilustraci\\xF3n_4",
    "data-name": "Ilustraci\\xF3n 4",
    transform: "translate(43.523 18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1634",
    "data-name": "Grupo 1634",
    transform: "translate(-43.523 -18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1095",
    "data-name": "Trazado 1095",
    d: "M152.639,34.9a14.391,14.391,0,1,1,14.39,14.391A14.388,14.388,0,0,1,152.639,34.9Zm22.412,0a8.028,8.028,0,1,0-16.042,0v.048a8.033,8.033,0,1,0,16.042-.048Z",
    transform: "translate(-98.233 -13.29)",
    fill: "#2d2e33"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_29",
    "data-name": "Elipse 29",
    cx: 3.564,
    cy: 3.564,
    r: 3.564,
    transform: "translate(79.917 3.541)",
    fill: "#2d2e33"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1096",
    "data-name": "Trazado 1096",
    d: "M49.047,29.9a13.239,13.239,0,0,1-1.9.182c-3.114,0-5.331-1.746-5.331-5.049V13.854h7.313a.566.566,0,0,0,.566-.566V8.523a.566.566,0,0,0-.566-.566H41.817V.612c0-.33-.189-.66-.8-.566-1.415.236-3.4.566-4.954.8a.728.728,0,0,0-.613.755V7.957H28.97V.566A.545.545,0,0,0,28.4,0H23.167A.545.545,0,0,0,22.6.566V10.05a13.98,13.98,0,0,0-8.116-2.689A14.44,14.44,0,0,0,0,21.609,14.5,14.5,0,0,0,14.485,36c5.58-.021,14.654-3.811,14.485-14.3V13.854h6.478V25.319c0,5.568,3.869,10.569,11.088,10.569a15.291,15.291,0,0,0,2.714-.232A.561.561,0,0,0,49.7,35.1v-4.64A.565.565,0,0,0,49.047,29.9ZM22.6,21.609A8.384,8.384,0,0,1,14.485,30.1a8.428,8.428,0,0,1,0-16.844,8.341,8.341,0,0,1,8.116,8.3Z",
    fill: "#2d2e33"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDto);
export default __webpack_public_path__ + "static/media/dto.8845b6df54ea7d58565ff78008d7bed4.svg";
export { ForwardRef as ReactComponent };